import { classes } from '@theme/constants';
import { gsap } from '@theme/gsap';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';

class FeaturedProducts extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.button) this.on('click', this.refs.button.all, this.handleButtonEvent.bind(this));
  }

  /**
   * Handles the button click event.
   * @param {MouseEvent} event - The mouse event.
   */
  handleButtonEvent(event) {
    for (const products of this.refs.products.all) {
      if (event.target.dataset.blockId === products.dataset.blockId) {
        gsap.to(products, {
          autoAlpha: 1,
          delay: 0.5,
        });

        gsap.fromTo(
          products.querySelectorAll('.product-card'),
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            stagger: 0.25,
            delay: 0.25,
          },
        );
      } else {
        gsap.to(products, {
          autoAlpha: 0,
        });
      }
    }

    for (const button of this.refs.button.all) {
      button.classList.toggle(classes.open, event.target.dataset.blockId === button.dataset.blockId);
    }

    for (const element of this.querySelectorAll('quick-add toggle-element')) {
      element.close();
    }
  }

  onBlockSelect(event) {
    this.handleButtonEvent(event);
  }
}

if (!customElements.get('featured-products')) customElements.define('featured-products', FeaturedProducts);
